export const formValidationConstants = {
  USER: {
    NAME: "User name is required.",
    EMAIL: "User email is required.",
    SCOPE: "Scope is required.",
    MFA_PHONE: "Phone number is required when MFA channel is SMS.",
    MFA_PHONE_FORMAT: "Enter a valid 10-digit US phone number.",
  },
};
